<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <div v-if="!loading">
      <div class="row">
        <div class="col" v-if="user.image">
          <v-lazy-image
            :src="user.image?user.image.large:'null'"
            class="rounded-circle"
            width="80"
          />
        </div>
      </div>

      <b-row>
        <b-col>
          <form-base-side-bar
            title
            action="Update"
            :errors="errors"
            :loading="loading"
            v-on:handleSubmit="handleSubmit"
          >
            <template v-slot:fields>
              <label class="form-group has-float-label mb-4">
                <input
                  type="text"
                  @blur="$v.user.name.$touch"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.name.$error }"
                  v-model="user.name"
                />
                <span>Full Name</span>
                <div class="invalid-feedback" v-if="!$v.user.name.required">Please enter full name</div>
              </label>

              <label class="form-group has-float-label mb-4">
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.email.$error }"
                  v-model="user.email"
                />
                <span>Email</span>
                <div
                  class="invalid-feedback"
                  v-if="!$v.user.email.required"
                >Please enter email address</div>
                <div class="invalid-feedback" v-if="!$v.user.email.email">invalid email address</div>
              </label>

              <label class="form-group has-float-label mb-4">
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.password.$error }"
                  v-model="user.password"
                />
                <span>Password</span>
                <small>Only enter a password if you want to change it</small>
                <div
                  class="invalid-feedback"
                  v-if="!$v.user.password.minLength"
                >Please enter password with a minimun of 6 characters</div>
              </label>

              <div class="form-group">
                <label class="form-label">Please select users roles</label>
                <span v-for="item in roles" :key="item.id">
                  <b-form-checkbox v-model="user.roles" :value="item.id">{{ item.name }}</b-form-checkbox>
                </span>
                <div class="text-danger" v-if="$v.user.roles.$error">Please select permissions</div>
              </div>

              <label>Profile Picture</label>
              <image-upload
              @files-uploaded="user.image_id = $event; imageUploading = false"
              @files-uploaded-started="imageUploading = true"
              :multiple=false
              :imageCrop=true
              :imageCropRatio=1/1
              :validationState="imageVstate"
              acceptedTypes="image/*"/>
            </template>
          </form-base-side-bar>
        </b-col>
      </b-row>

      <div class="row">
        <div class="col">
          <hr />
          <h5>Role Definitions:</h5>
          <span v-for="role in roles" :key="role.id">
            <p class="text-muted text-small mb-3 font-weight-bold">{{ role.name }}'s can:</p>
            <ul class="list-unstyled mb-4">
              <li
                class="nav-item"
                v-for="permission in role.permissions"
                :key="permission.id"
              >- {{ permission.name }}</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";
import roleRepo from "@/api/repos/roleRepo";
import { required, email, minLength } from "vuelidate/lib/validators";
import formBaseSideBar from "@/components/common/FormBaseSideBar";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBaseSideBar,
    imageUpload
  },

  computed: {
    imageVstate: function() {
      return null;
    }
  },

  props: ["id"],

  mounted() {
    this.getUser();
    this.getRoles();
  },

  validations: {
    user: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        minLength: minLength(6)
      },
      roles: {
        required
      }
    }
  },

  data() {
    return {
      user: {},
      roles: [],
      loading: false,
      errors: [],
      imageUploading: false
    };
  },

  methods: {
    async getRoles() {
      try {
        let { data } = await roleRepo.roles(1, 1000, "name", "asc", "");
        this.roles = data.roles.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getUser() {
      try {
        this.loading = true
        let { data } = await userRepo.get(this.id);
        this.user = data.user;
        this.user.roles = this.user.roles.map(x => x.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
      } else {
        try {
          await userRepo.update(this.id, this.user);
          this.$emit("userUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
          }
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
